import { render, staticRenderFns } from "./CustomMobile.vue?vue&type=template&id=5413382a&scoped=true&"
import script from "./CustomMobile.vue?vue&type=script&lang=js&"
export * from "./CustomMobile.vue?vue&type=script&lang=js&"
import style0 from "./CustomMobile.vue?vue&type=style&index=0&id=5413382a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5413382a",
  null
  
)

export default component.exports